module.exports = __webpack_public_path__ + "static/media/hanuman-ji.7845c528.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/hanuman-ji.gif
// module id = 539
// module chunks = 0